import React from "react";
import { makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Tooltip from '@material-ui/core/Tooltip';

import BulletList from '@material-ui/icons/FormatListBulleted';
import NumList from '@material-ui/icons/FormatListNumbered';

const useStyles = makeStyles(theme => ({
    active: {
        backgroundColor: 'rgba(0, 0, 0, 0.10);',
        "&:hover" : {
            backgroundColor: 'background-color: rgba(0, 0, 0, 0.10);',
        }
    },
}));

const BLOCK_TYPES = [
    { id: "ordered-list-item", icon: <NumList/>, style: "ordered-list-item", label: "Ordered List"},
    { id: "unordered-list-item", icon: <BulletList/>, style: "unordered-list-item", label: "Unordered List"}
];

export default function List(props) {

    const classes = useStyles();

    const { editorState, onToggle } = props;

    const selection = editorState.getSelection();
    const blockType = editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();

    const onClick = (event, style) => {
        event.preventDefault();
        onToggle(style);
    }

    return (
        <ButtonGroup>
            {BLOCK_TYPES.map((type, i) => (
                <Tooltip title={type.label} key={i}>
                    <Button
                        id={type.id}
                        size="small"
                        className={type.style === blockType ? classes.active : null}
                        onMouseDown={(event) => onClick(event, type.style)}
                        >
                        {type.icon}
                    </Button>
                </Tooltip>
            ))}
        </ButtonGroup>
    );
}
